<template>
  <div>
    <app-page>
      <template #header>
        <div class="fan-search">
          <div class="fan-search-right">
            <!-- 新增 -->
            <div v-if="$has('FWS-DZZX-DZZT-XZ')">
              <el-button
                type="primary" :size="formSize" @click="handleModify(false)"
                v-track
                trackCode='tradeMainList-1'
              >新增</el-button>
            </div>
          </div>
        </div>
      </template>
      <template #main="{ height }">
        <jr-table
          :height="height"
          :key="height"
          :loading="loading"
          :tableData="list"
          :tableColumn="tableColumn"
        />
      </template>

      <template #ffooter>
        <pagination
          :total="total"
          :current-page="queryForm.page"
          :size="queryForm.limit"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </app-page>

    <!-- 新增/编辑 -->
    <modify-dialog
      :visible.sync="isModifyShow"
      :is-modify="isModify"
      :current-obj="currentRow"
      @success="getList"
    />

    <jr-operate-dialog
      :visible.sync="isOperateDelShow"
      :text-config.sync="textConfig"
      :loading="delLoading"
      @submit="delSubmit"
    />

  </div>
</template>

<script>
import { getConfigList, delConfig } from '@/api/counting';
import modifyDialog from './components/modify-dialog';

const formDefault = {
  page: 1,
  limit: 20,
  transType: 2, // 对账类型 0平台商 1服务商
};

export default {
  name: 'tradeMainList',
  components: { modifyDialog },
  data() {
    return {
      loading: false,
      queryForm: { ...formDefault },
      list: [],
      total: 0,
      tableColumn: [
        { type: 'index', label: '序号', width: '50px' },
        { prop: 'merchantName', label: '主体名称', minWidth: '1' },
        { prop: 'merchantNo', label: '主体编号', minWidth: '1' },
        { prop: 'channelTypeDesc', label: '所属渠道', minWidth: '1' },
        { prop: 'countingItem', label: '对账项目', minWidth: '1' },
        { prop: 'statusDesc', label: '状态', minWidth: '1' },
        {
          label: '操作',
          width: '120px',
          btnGroups: [
            {
              name: '编辑',
              plain: true,
              className: ['table-button', 'table-button-success'],
              trackCode: 'tradeMainList-2',
              showBtn: () => this.$has('FWS-DZZX-DZZT-BJ'),
              click: (row) => this.handleModify(true, row),
            },
            {
              name: '删除',
              plain: true,
              className: ['table-button', 'table-button-danger'],
              trackCode: 'tradeMainList-3',
              showBtn: (row) => this.$has('FWS-DZZX-DZZT-XC') && row.buttonFlag === 1,
              click: (row) => this.handleDel(row),
            },
          ],
        },
      ],
      isModifyShow: false,
      isModify: false,
      currentRow: {},
      isOperateDelShow: false,
      textConfig: {},
      delLoading: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 删除
    handleDel(row) {
      this.isOperateDelShow = true;
      this.textConfig = {
        title: '提示',
        messageTip: '是否删除该对账主体?',
        isPass: true,
      };
      this.currentRow = { ...row };
    },
    async delSubmit() {
      try {
        this.delLoading = true;
        await delConfig({ id: this.currentRow.id });
        this.$message.success('删除成功!');
        this.delLoading = false;
        this.isOperateDelShow = false;
        this.getList();
      } catch (error) {
        console.log(error);
        this.delLoading = false;
      }
    },
    // 新增/编辑
    handleModify(flag, row = {}) {
      this.isModify = flag;
      this.isModifyShow = true;
      this.currentRow = { ...row };
    },
    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },
    // 列表查询
    async getList() {
      try {
        this.loading = true;
        const res = await getConfigList(this.queryForm);
        this.total = res.totalCount || 0;
        this.list = res.data || [];
      } catch (error) {
        console.log(error);
        this.list = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
